import { type Plugin } from "@nuxt/types";

import MetaService from "@/utils/services/MetaService";

declare module "vue/types/vue" {
  interface Vue {
    $metaService: MetaService;
  }
}

declare module "@nuxt/types" {
  interface Context {
    $metaService: MetaService;
  }
}

declare module "vuex/types/index" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Store<S> {
    $metaService: MetaService;
  }
}

const plugin: Plugin = (context, inject) => {
  const metaService = new MetaService(context);

  inject("metaService", metaService);
  context.$metaService = metaService;
};

export default plugin;
